import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getLoggedInUser } from "../helpers/fakebackend_helper";

// Define a functional component called Navdata
const Navdata = () => {
  // Access the React Router history object for navigation
  const history = useNavigate();

  // Define state variables to track the active menu items
  const [isProject, setIsProject] = useState(false);
  const [isModule, setIsModule] = useState(false);
  const [isUsers, setIsUsers] = useState(false);
  const [isDashboard, setIsDashboard] = useState(false);
  const [isEmployee, setIsEmployee] = useState(false);
  const [isAdvance, setIsAdvance] = useState(false);
  const [isAudit, setIsAudit] = useState(false);
  // Get the logged-in user using a helper function
  const authUser = getLoggedInUser();

  // Define a variable to indicate if the user is an administrator
  const isAdmin = true;

  // Define a state variable to keep track of the currently selected menu item
  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  // Function to update the appearance of the sidebar icons
  function updateIconSidebar(e) {
    // Check if the event target has a "subitems" attribute
    if (e && e.target && e.target.getAttribute("subitems")) {
      // Get the list of active icon items in the sidebar
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      // Remove the "active" class from active icon items
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        // Hide subitems if they exist
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  // useEffect hook to perform side effects when dependencies change
  useEffect(() => {
    // Remove a specific CSS class from the body element
    document.body.classList.remove("twocolumn-panel");

    // Conditionally navigate to different routes based on the current state
    if (iscurrentState === "Project") {
      history("/project");
      setIsProject(false);
    }
    if (iscurrentState === "Employee") {
      history("/employee-list");
      setIsProject(false);
    }
    if (iscurrentState === "Audit") {
      history("/audit-list");
      setIsProject(false);
    }

    if (iscurrentState === "Modules") {
      history("/modules");
      setIsModule(false);
    }
    if (iscurrentState === "Advance") {
      history("/advance-list");
      setIsModule(false);
    }
  }, [history, iscurrentState, isProject, isModule]);

  // Define an array of menu items
  const menuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "Dashboard",
      label: "Dashboard",
      link: "/dashboard",
      // Click handler to toggle the "Dashboard" menu item
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
      },
    },
    // {
    //   id: "Projects",
    //   label: "User Management",
    //   icon: "ri-honour-line",
    //   link: "/project",
    //   // Click handler to toggle the "Projects" menu item
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsProject(!isProject);
    //     setIscurrentState('Project');
    //   }
    // },
    {
      id: "Employee",
      label: "Reports",
      icon: "ri-file-chart-line",
      link: "/report",
      // Click handler to toggle the "Projects" menu item
      click: function (e) {
        e.preventDefault();
        setIsProject(!isEmployee);
        setIscurrentState("Employee");
      },
    },
    {
      id: "Audit",
      label: "Audit Report",
      icon: "ri-file-chart-line",
      link: "/audit-list",
      // Click handler to toggle the "Projects" menu item
      click: function (e) {
        e.preventDefault();
        setIsProject(!isAudit);
        setIscurrentState("Audit");
      },
    },
    // {
    //   id: "CAT",
    //   label: "CAT",
    //   icon: "ri-file-chart-line",
    //   link: "/cat",
    //   // Click handler to toggle the "Projects" menu item
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsProject(!isEmployee);
    //     setIscurrentState("Employee");
    //   },
    // },

    {
      id: "CIC",
      label: "CIC",
      icon: "ri-file-chart-line",
      link: "/cic",
      // Click handler to toggle the "Projects" menu item
      click: function (e) {
        e.preventDefault();
        setIsProject(!isEmployee);
        setIscurrentState("Employee");
      },
    },
    {
      id: "Advance Records",
      label: "Upload Document",
      icon: "ri-file-upload-line",
      link: "/document",
      // Click handler to toggle the "Projects" menu item
      click: function (e) {
        e.preventDefault();
        setIsProject(!isAdvance);
        setIscurrentState("Advance");
      },
    },
  ];

  // If the user is an admin, add a "Users" (or "Team") menu item
  if (isAdmin) {
    const usersSection = {
      id: "Users",
      label: "Settings",
      icon: "ri-team-line",
      link: "/settings",
      parentId: "Users",
      // Click handler to toggle the "Users" menu item
      click: function (e) {
        e.preventDefault();
        setIsUsers(!isUsers);
        setIsUsers("Users"); // There's a typo here, it should probably be setIscurrentState('Users')
      },
      stateVariables: isUsers,
      subItems: [
        {
          id: "Users",
          label: "Update Profile",
          link: "/update-profile",
          parentId: "Users",
        },
        {
          id: "Users",
          label: "View Profile",
          link: "/view-profile",
          parentId: "Users",
        },
        {
          id: "Users",
          label: "User Management",
          link: "/user-management",
          parentId: "Users",
        },
        {
          id: "Users",
          label: "Change Password",
          link: "/change-password",
          parentId: "Users",
        },
      ],
    };
    menuItems.push(usersSection);
  }

  // Return the menu items as a React fragment
  return <React.Fragment>{menuItems}</React.Fragment>;
};

// Export the Navdata component as the default export
export default Navdata;
